import Scheduler from '../components/scheduler/Scheduler';
import { Helmet } from 'react-helmet-async';

const MeetingPage = () => {
    return (
        <div>
            <Helmet>
                <title>Room 49 - Book the meeting room</title>
                <meta name="description" content="Need a private space for a client call or catch-up? The meeting room at Room 49 is available to book for short sessions when you need it." />
                <link rel="canonical" href='https://thetypingrooms.co.uk/meeting' />
            </Helmet>
            <div className="page">
                <div className="page-header">
                    <h1>Book the basement</h1>
                </div>
                <div className='page-content'>
                    <p>
                        The private meeting room downstairs has a table, sofa, whiteboard and projector, making it ideal for video calls, quiet work or small meetings. If you have booked a desk, you can book the meeting room for up to 2 hours a day. Just enter your details below and your booking will appear on the calendar.
                    </p>
                </div>
                <Scheduler />
            </div>
        </div>
    );
};

export default MeetingPage;